// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"130":"provider-table","179":"main","478":"collection-table","543":"full-page"}[chunkId] + "." + {"130":"92a956fe","179":"5730783a","478":"92a956fe","543":"0a79df2f"}[chunkId] + ".css";
};